module.exports = __webpack_public_path__ + "img/process.838d145b.png";